import React from "react";
import { Table, Input, Popconfirm, Form, message, Button } from "antd";
import { updateSignature, getSignatureList } from "../../api/message";
import { formatMessage } from "@/utils/format";
import "./style.less";

const FormItem = Form.Item;
const EditableContext = React.createContext();
const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);
const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  getInput = () => {
    return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {form => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [
                      {
                        required: true,
                        message: `Please Input ${title}!`
                      }
                    ],
                    initialValue: record[dataIndex].replace(/[【】]/g, "")
                  })(this.getInput())}
                </FormItem>
              ) : (
                restProps.children
              )}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}

class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editingKey: "",
      data: [],
      current: 0,
      total: 0
    };
    this.columns = [
      {
        title: "申请时间",
        dataIndex: "ctime",
        width: "20%"
      },
      {
        title: "签名",
        dataIndex: "signContent",
        width: "20%",
        editable: true
      },
      {
        title: "审核状态",
        dataIndex: "status",
        width: "15%"
      },
      {
        title: "未通过原因",
        dataIndex: "detail",
        width: "30%"
      },
      {
        title: "操作",
        dataIndex: "operation",
        render: (text, record) => {
          const editable = this.isEditing(record);
          const status = record.status;
          return status === "success" ? (
            ""
          ) : (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <Popconfirm
                        title="确定取消吗?"
                        onConfirm={() => this.save(form, record.key)}
                      >
                        <a
                          href="javascript:;"
                          style={{ marginRight: 8 }}
                        >
                          保存
                        </a>
                      </Popconfirm>
                    )}
                  </EditableContext.Consumer>
                  <a onClick={() => this.cancel(record.key)}>取消</a>
                </span>
              ) : (
                <a href="javascript:;" onClick={() => this.edit(record.key)}>
                  编辑
                </a>
              )}
            </div>
          );
        }
      }
    ];
  }

  renderData = (data, page) => {
    let signatureList = data.userSmsSigns;
    signatureList = signatureList.map((item, key) =>
      formatMessage(item, key + Math.random())
    );
    this.setState({
      data: signatureList,
      total: data.totalPage * 4,
      current: page ? page : 0
    });
  };

  componentWillMount() {
    getSignatureList(null, 4).then(data => this.renderData(data));
  }

  handleChangePage = page => {
    getSignatureList(this.props.status, 4, page.current - 1).then(data =>
      this.renderData(data, page.current)
    );
  };

  getStatusList = (status, size) => {
    getSignatureList(status, size).then(data => this.renderData(data));
  };

  isEditing = record => record.key === this.state.editingKey;

  cancel = () => {
    this.setState({ editingKey: "" });
  };

  save(form, key) {
    form.validateFields((error, row) => {
      if (error) {
        console.log(error, 'error');
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row
        });
        const sign = newData[index].signContent;
        if (
          /^[\u4e00-\u9fa5a-zA-Z]{3,8}$/.test(sign) &&
          !/^[a-zA-Z]$/.test(sign)
        ) {
          updateSignature(item, sign).then(res => {
            this.setState({ data: newData, editingKey: "" }, () => {
              this.props.update(newData);
              message.success("修改成功");
            });
          });
        } else {
          message.error("格式错误，请输入3到8个字的中英文(不要输入'[]')");
        }
      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: "" });
      }
    });
  }

  edit(key) {
    this.setState({ editingKey: key });
  }

  render() {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell
      }
    };

    const columns = this.columns.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record)
        })
      };
    });

    return (
      <div className="signTable">
        <Button
          className="searchBtn"
          type="primary"
          onClick={() => {
            this.getStatusList(this.props.status, 4);
          }}
        >
          搜索
        </Button>
        <Table
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
          onChange={this.handleChangePage}
          pagination={{
            pageSize: 4,
            current: this.state.current,
            total: this.state.total
          }}
        />
      </div>
    );
  }
}
export default EditableTable;
